import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { db } from '../Config/Config';
import noImage from '../assets/no-image-icon-23485.png';



const fadeUp = { hidden: { opacity: 0, y: 16 }, visible: { opacity: 1, y: 0, transition: { duration: 0.5 } } };
const stagger = { hidden: {}, visible: { transition: { staggerChildren: 0.08 } } };

const Services = () => {
  const { pathname } = useLocation();
  const isStandalone = pathname === '/services';
  const sectionProps = isStandalone
    ? { variants: stagger, initial: 'hidden', animate: 'visible' }
    : { variants: stagger, initial: 'hidden', whileInView: 'visible', viewport: { once: true, amount: 0.1 } };
    const [services, setServices] = useState([]);
    useEffect(() => {
      serviceData();
    }, []);
   
  const serviceData = async () => {
      const ref = query(
      collection(db, "website-management", "service", "data"),
      orderBy("order", "asc")
    );;
      const snap = await getDocs(ref);

      const arr = snap.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      setServices(arr);
    }
  return (
    <motion.section className="py-10 max-w-7xl mx-auto" {...sectionProps}>
      <motion.h3 variants={fadeUp} className="text-2xl md:text-2xl font-bold mb-6 text-brand-primary/90">Services</motion.h3>
      <motion.div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-6" variants={stagger}>
        {services.map((item, i) => (
          <motion.div key={i} variants={fadeUp} className="group p-4   hover:shadow-lg transition-shadow text-center border border-slate-100">
            <img alt="service" className="w-full h-28  mb-3" src={item.image || noImage} />
            <h4 className="font-medium text-lg text-brand-primary/90">{item.title}</h4>
            <p className="text-sm text-slate-600 mt-1">{item.description}</p>
          </motion.div>
        ))}
      </motion.div>
    </motion.section>
  );
};

export default Services;
